import React from "react";
import MobileTitleOthersData from "./TitleOthersData";

function MobileOthersPro({ Data, getData, projectList, projectId ,Unit}) {
  

  return (
    <div className=" w-full  h-[70vh] overflow-y-auto">
      {Data &&
        Data.map((item, idx) => {
          return (
            <MobileTitleOthersData rowData={item} key={idx} getData={getData} projectList={projectList} projectId={projectId}  Unit={Unit} />
          );
        })}
    </div>
  );
}

export default MobileOthersPro;
